module.exports = {
      id: "icon-pause-usage",
      viewBox: "0 0 17.726 22.137",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }